import { Banner } from "@/components";

const BannerApp = (props, rails) => () => <Banner {...props} />;

export default BannerApp;
